import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

const AboutSelect = props => {
  const { selection } = props;
  const isMobileView = useMediaQuery('(max-width: 1200px)');

  return (
    <Paper square>
      <Tabs
        value={selection}
        indicatorColor="primary"
        textColor="primary"
        centered={!isMobileView}
        allowScrollButtonsMobile
        variant={isMobileView ? 'scrollable' : 'fullWidth'}
      >
        <Link href="/about">
          <Tab label="ABOUT" />
        </Link>
        <Link href="/about/brand">
          <Tab label="BRAND" />
        </Link>
        <Link href="/about/team">
          <Tab label="TEAM" />
        </Link>
        <Link href="/about/faq">
          <Tab label="FAQ" />
        </Link>
        <Link href="/about/contact">
          <Tab label="CONTACT" />
        </Link>
        <Link href="/about/terms">
          <Tab label="TERMS" />
        </Link>
        <Link href="/about/privacy">
          <Tab label="PRIVACY" />
        </Link>
        <Link href="/about/cookies">
          <Tab label="COOKIES" />
        </Link>
        <Link href="/about/affiliate-disclosure">
          <Tab label="AFFILIATE DISCLOSURE" />
        </Link>
        <Link href="/about/support-us">
          <Tab label="SUPPORT US" />
        </Link>
        <Link href="/about/community-standards">
          <Tab label="COMMUNITY STANDARDS" />
        </Link>
      </Tabs>
    </Paper>
  );
};

AboutSelect.propTypes = {
  selection: PropTypes.number.isRequired,
};

export default AboutSelect;
